/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The reviewer's ground-truth verdict for this session.
 */
export const SaveRiskEvalReviewRequestBodyVerdict = {
  Correct: "correct",
  FalsePositive: "false_positive",
  Missed: "missed",
} as const;
/**
 * The reviewer's ground-truth verdict for this session.
 */
export type SaveRiskEvalReviewRequestBodyVerdict = ClosedEnum<
  typeof SaveRiskEvalReviewRequestBodyVerdict
>;

export type SaveRiskEvalReviewRequestBody = {
  /**
   * The chat session being judged.
   */
  chatId: string;
  /**
   * The prompt-based policy the verdict belongs to.
   */
  policyId: string;
  /**
   * The reviewer's ground-truth verdict for this session.
   */
  verdict: SaveRiskEvalReviewRequestBodyVerdict;
};

/** @internal */
export const SaveRiskEvalReviewRequestBodyVerdict$outboundSchema: z.ZodMiniEnum<
  typeof SaveRiskEvalReviewRequestBodyVerdict
> = z.enum(SaveRiskEvalReviewRequestBodyVerdict);

/** @internal */
export type SaveRiskEvalReviewRequestBody$Outbound = {
  chat_id: string;
  policy_id: string;
  verdict: string;
};

/** @internal */
export const SaveRiskEvalReviewRequestBody$outboundSchema: z.ZodMiniType<
  SaveRiskEvalReviewRequestBody$Outbound,
  SaveRiskEvalReviewRequestBody
> = z.pipe(
  z.object({
    chatId: z.string(),
    policyId: z.string(),
    verdict: SaveRiskEvalReviewRequestBodyVerdict$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      chatId: "chat_id",
      policyId: "policy_id",
    });
  }),
);

export function saveRiskEvalReviewRequestBodyToJSON(
  saveRiskEvalReviewRequestBody: SaveRiskEvalReviewRequestBody,
): string {
  return JSON.stringify(
    SaveRiskEvalReviewRequestBody$outboundSchema.parse(
      saveRiskEvalReviewRequestBody,
    ),
  );
}
